
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sales-crm",
      function () {
        return require("private-next-pages/sales-crm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sales-crm"])
      });
    }
  